export const FETCH_START      = "PopularDesigns/FETCH_START"
export const FETCH_SUCCESS    = "PopularDesigns/FETCH_SUCCESS"
export const FETCH_FAILED     = "PopularDesigns/FETCH_FAILED"
